<div 
    *ngFor="let contentElement of element.content" 
    [ngStyle]="getElementStyle(contentElement)"
>
    <element-render 
        [contentElement]="contentElement" 
        [questionState]="questionState"
        [isLocked]="isLocked"
        [contentElement]="contentElement"
        [questionPubSub]="questionPubSub"
        [isShowSolution]="isShowSolution"
    ></element-render>
</div> 
